import { FaRegEdit } from 'react-icons/fa'
import { FaTrashCan } from 'react-icons/fa6'
import { OverlayTrigger, Popover } from "react-bootstrap";
import useCheckUserRole from '../../BasketPage/Hooks/useCheckUserRole.ts';
import { UserRole } from '../../../Data/UserRolesEnum.ts';

const AuthorizedPerson = ({ user, index, onEdit, onDelete }) => {
    function reverseDate(date) {
        try {
            const [year, month, day] = date.split('-')
            return `${day}-${month}-${year}`
        } catch {
            return ''
        }

    }

    const { isUserHasAccess } = useCheckUserRole()

    const popover = (text) => <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>{text}</span>
        </Popover.Body>
    </Popover>

    return (
        user &&
        <tr className='hoverable-row'>
            <td style={{ textAlign: 'center' }}>
                {index + 1}
            </td>
            <td>
                {user.name + ' ' + user.surname}
            </td>
            <td>
                {user.position ? user.position : ''}
            </td>
            <td>
                {user.phoneNumber ? user.phoneNumber : ''}
            </td>
            <td >
                {user.email}
            </td>
            <td>{!user.effectiveDate || user.effectiveDate === '' ? 'Bezterminowy' : reverseDate(user.effectiveDate.substring(0, user.effectiveDate.indexOf('T')))}</td>
            {isUserHasAccess(UserRole.Admin) && <td style={{ textAlign: 'center' }}>
                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Edytuj')}>
                    <button onClick={() => onEdit(user)} style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                        <FaRegEdit color='black' />
                    </button>
                </OverlayTrigger>
            </td>}
            {isUserHasAccess(UserRole.Admin) && <td style={{ textAlign: 'center' }}>
                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Usuń')}>
                    <button onClick={() => onDelete(user)} style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                        <FaTrashCan color='black' />
                    </button>
                </OverlayTrigger>
            </td>}
        </tr>
    )
}

export default AuthorizedPerson
